/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { AccessorNodeDependencies } from './dependenciesAccessorNode.generated';
import { ArrayNodeDependencies } from './dependenciesArrayNode.generated';
import { AssignmentNodeDependencies } from './dependenciesAssignmentNode.generated';
import { BlockNodeDependencies } from './dependenciesBlockNode.generated';
import { ConditionalNodeDependencies } from './dependenciesConditionalNode.generated';
import { ConstantNodeDependencies } from './dependenciesConstantNode.generated';
import { FunctionAssignmentNodeDependencies } from './dependenciesFunctionAssignmentNode.generated';
import { FunctionNodeDependencies } from './dependenciesFunctionNode.generated';
import { IndexNodeDependencies } from './dependenciesIndexNode.generated';
import { ObjectNodeDependencies } from './dependenciesObjectNode.generated';
import { OperatorNodeDependencies } from './dependenciesOperatorNode.generated';
import { ParenthesisNodeDependencies } from './dependenciesParenthesisNode.generated';
import { RangeNodeDependencies } from './dependenciesRangeNode.generated';
import { RelationalNodeDependencies } from './dependenciesRelationalNode.generated';
import { SymbolNodeDependencies } from './dependenciesSymbolNode.generated';
import { numericDependencies } from './dependenciesNumeric.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createParse } from '../../factoriesAny.js';
export var parseDependencies = {
  AccessorNodeDependencies: AccessorNodeDependencies,
  ArrayNodeDependencies: ArrayNodeDependencies,
  AssignmentNodeDependencies: AssignmentNodeDependencies,
  BlockNodeDependencies: BlockNodeDependencies,
  ConditionalNodeDependencies: ConditionalNodeDependencies,
  ConstantNodeDependencies: ConstantNodeDependencies,
  FunctionAssignmentNodeDependencies: FunctionAssignmentNodeDependencies,
  FunctionNodeDependencies: FunctionNodeDependencies,
  IndexNodeDependencies: IndexNodeDependencies,
  ObjectNodeDependencies: ObjectNodeDependencies,
  OperatorNodeDependencies: OperatorNodeDependencies,
  ParenthesisNodeDependencies: ParenthesisNodeDependencies,
  RangeNodeDependencies: RangeNodeDependencies,
  RelationalNodeDependencies: RelationalNodeDependencies,
  SymbolNodeDependencies: SymbolNodeDependencies,
  numericDependencies: numericDependencies,
  typedDependencies: typedDependencies,
  createParse: createParse
};